Ext.define('SA.view.ImportColumnRow', {
    constructor(headerName) {
        this.headerName = headerName;

        this.el = Ext.DomHelper.createDom({tag: 'tr', cls: 'sa-import-column-row'});

        this.buildComponents(headerName);

        this.selectedCheckBox.on('change', this.refresh, this);
        this.typeDropDown.on('change', this.refresh, this);
    },

    buildComponents(headerName) {
        var me = this,
            cfgs = [
                {
                    xtype: 'sa-checkbox',
                    itemId: 'selectedCheckBox',
                    checked: true
                }, {
                    xtype: 'component',
                    cls: 'sa-import-column-row-name-label',
                    itemId: 'rowNameLabel',
                    html: Ext.String.htmlEncode(headerName)
                },
                getDropDownCfg({
                    itemId: 'typeDropDown',
                    items: this.getTypeDropDownItems(),
                    width: 110
                }),
                getDropDownCfg({
                    cls: 'sa-import-column-row-format-drop-down',
                    itemId: 'formatDropDown',
                    disabled: true,
                    width: 145
                }),
                {
                    xtype: 'sa-text-field',
                    cls: 'sa-import-column-row-friendly-name-text-field',
                    disabled: true,
                    itemId: 'friendlyNameTextField',
                    height: 40,
                    maxLength: 150,
                    width: 240
                }
            ];

        cfgs.forEach(buildComponent);

        function buildComponent(cfg) {
            var td = document.createElement('td');

            me[cfg.itemId] = Ext.widget(Object.assign(cfg, {renderTo: td}));

            me.el.appendChild(td);
        }

        function getDropDownCfg({cls, disabled, itemId, items = [], width}) {
            var xtype = 'combo-button',
                valueField = 'id',
                textField = 'label';

            return {xtype, cls, disabled, itemId, items, textField, valueField, width};
        }
    },

    getEl() {
        return this.el;
    },

    getType() {
        return this.typeDropDown.getValue();
    },

    getTypeDropDownItems() {
        var types = SA.data.AttributeTypes.getTypes(),
            locationTypeItem = {id: 'location', label: 'Location ID'};

        return [locationTypeItem, ...types.map(mapType)];

        function mapType(type) {
            var id = type,
                label = SA.data.AttributeTypes.getTextForType(type);

            return {id, label};
        }
    },

    getValue() {
        return ({
            headerName: this.headerName,
            friendlyName: this.friendlyNameTextField.getValue().trim(),
            type: this.getType(),
            format: this.formatDropDown.getValue()
        });
    },

    isLocationColumn() {
        return this.getType() === 'location';
    },

    isRowSelected() {
        return this.selectedCheckBox.isChecked();
    },

    maybeResetControls() {
        var isRowUnselected = !this.isRowSelected();

        if (isRowUnselected) {
            this.typeDropDown.setValue(null);
        }

        if (isRowUnselected || this.isLocationColumn()) {
            this.formatDropDown.setValue(null);
            this.friendlyNameTextField.setValue(null);
        }
    },

    refresh() {
        this.maybeResetControls();

        this.refreshControlVisibility();
        this.refreshFormatDropDown();
        this.refreshFriendlyNameTextFieldEnabled();
    },

    refreshControlVisibility() {
        var isRowSelected = this.isRowSelected(),
            isNotLocationColumn = !this.isLocationColumn();

        this.typeDropDown.setVisible(isRowSelected);
        this.formatDropDown.setVisible(isRowSelected && isNotLocationColumn);
        this.friendlyNameTextField.setVisible(isRowSelected && isNotLocationColumn);
    },

    refreshFormatDropDown() {
        var items = getItemsForType(this.getType()),
            itemCount = items.length;

        this.formatDropDown.setItems(items);
        this.formatDropDown.setEnabled(itemCount > 1);

        if (itemCount === 1) {
            this.formatDropDown.setValue(items[0].id);
        }

        function getItemsForType(type) {
            var Formats = SA.data.AttributeFormats,
                formats = Formats.getFormatsForAttributeType(type),
                getLabel = format => Formats.getTextForFormat(format),
                mapFormat = format => ({id: format, label: getLabel(format)});

            return formats.map(mapFormat);
        }
    },

    refreshFriendlyNameTextFieldEnabled() {
        var type = this.getType(),
            enable = type !== null && type !== 'location';

        this.friendlyNameTextField.setEnabled(enable);
    }
});